import {Authorizations} from "../../../../authorization/Authorizations";

export function authorizationTitleRemapping(authorization: string): string {
    if(authorization === Authorizations.PlanningHubPayroll) {
        return "View and Edit Payroll";
    }
    if(authorization === Authorizations.ManageUsers) {
        return "Manage Users";
    }
    return authorization;
}